module.exports = __webpack_public_path__ + "static/media/melon.85da7b34.svg";